export const pathFinder = {
  // info pages
  '': {
    name: 'home',
    type: 'homepage',
  },
  // info pages
  '/about-us': {
    name: 'about-us',
    type: 'general-info',
  },
  '/contact': {
    name: 'contact',
    type: 'general-info',
  },
  // landing pages
  '/free-wifi-on-london-underground': {
    name: 'free-wifi-on-london-underground',
    type: 'landing-page',
  },
  '/5g': {
    name: '5g',
    type: 'landing-page',
  },
  '/christmas-sim-deals': {
    name: 'christmas-sim-deals',
    type: 'landing-page',
  },
  '/january-sale-sim-deals': {
    name: 'january-sale-sim-deals',
    type: 'landing-page',
  },
  '/50gb-sim-deals': {
    name: '50gb-sim-deals',
    type: 'landing-page',
  },
  '/data-rollover': {
    name: 'data-rollover',
    type: 'landing-page',
  },
  '/app': {
    name: 'app',
    type: 'landing-page',
  },
  '/fist-bump': {
    name: 'fist-bump',
    type: 'landing-page',
  },
  '/family-sim-deals': {
    name: 'family-sim-deals',
    type: 'landing-page',
  },
  '/cheap-sim-deals': {
    name: 'cheap-sim-deals',
    type: 'landing-page',
  },
  '/no-rolling-contract-sim': {
    name: 'no-rolling-contract-sim',
    type: 'landing-page',
  },
  '/iphone-fist-bump': {
    name: 'iphone-fist-bump',
    type: 'landing-page',
  },
  '/discovery-free-prize-draw': {
    name: 'discovery-free-prize-draw',
    type: 'landing-page',
  },
  '/data-sim': {
    name: 'data-sim',
    type: 'landing-page',
  },
  '/dashboard/groups/data-only-plans': {
    name: 'data-only-plans',
    type: 'landing-page',
  },
  '/mobile-broadband-sim': {
    name: 'mobile-broadband-sim',
    type: 'landing-page',
  },
  '/friend': {
    name: 'friend',
    type: 'landing-page',
  },
  '/group-plans': {
    name: 'group-plans',
    type: 'landing-page',
  },
  '/iphone-quiz': {
    name: 'iphone-quiz',
    type: 'landing-page',
  },
  '/money-back': {
    name: 'money-back',
    type: 'landing-page',
  },
  '/no-credit-check-sim': {
    name: 'no-credit-check-sim',
    type: 'landing-page',
  },
  '/no-funny-business': {
    name: 'no-funny-business',
    type: 'landing-page',
  },
  '/no-long-contracts': {
    name: 'no-long-contracts',
    type: 'landing-page',
  },
  '/no-nonsense': {
    name: 'no-nonsense',
    type: 'landing-page',
  },
  '/no-silly-packages': {
    name: 'no-silly-packages',
    type: 'landing-page',
  },
  '/order-your-free-sim': {
    name: 'order-your-free-sim',
    type: 'landing-page',
  },
  '/pay-as-you-go': {
    name: 'pay-as-you-go',
    type: 'landing-page',
  },
  '/refer-a-friend': {
    name: 'refer-a-friend',
    type: 'landing-page',
  },
  '/free-sim': {
    name: 'free-sim',
    type: 'landing-page',
  },
  '/unlimited-sim-deals': {
    name: 'unlimited-sim-deals',
    type: 'landing-page',
  },
  '/sim-only': {
    name: 'sim-only',
    type: 'landing-page',
  },
  '/student-sim': {
    name: 'student-sim',
    type: 'landing-page',
  },
  // support pages
  '/calling-abroad': {
    name: 'calling-abroad',
    type: 'support-help',
  },
  '/calling-abroad/countries': {
    name: 'calling-abroad.countries',
    type: 'support-help',
  },
  '/coverage-checker': {
    name: 'coverage-checker',
    type: 'support-help',
  },
  '/roaming': {
    name: 'roaming',
    type: 'support-help',
  },
  '/roaming/europe': {
    name: 'roaming.europe',
    type: 'support-help',
  },
  '/roaming/international': {
    name: 'roaming.international',
    type: 'support-help',
  },
  '/roaming-setup': {
    name: 'roaming-setup',
    type: 'support-help',
  },
}
